/* ------------------------------------------------------------------
   Solis custom JS — Framia
   All our custom behaviour lives here. Loaded from layout/theme.liquid.
   Bind to Framia's documented events so enhancements survive AJAX
   re-renders (variant change, filtered collection re-render, cart update).
   Events ref: docs.foxecom.com/pebble-theme/faqs/javascript-events-for-developers
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  // Apply Solis enhancements. `scope` is the document or a re-rendered fragment.
  function applyEnhancements(scope) {
    // Bindings are added here as features are built. Kept idempotent so it can
    // safely run again after each AJAX re-render below.
    initArtistBioReadMore(scope);
    initSolisKlaviyoPopup(scope);
    startSolisKlaviyoObserver();
  }

  // PDP artist bio: collapse long bios behind a "Read more" toggle that expands
  // with a fade (CSS handles the clamp/fade; JS animates the accordion height).
  function initArtistBioReadMore(scope) {
    (scope || document).querySelectorAll('[data-solis-bio]').forEach(function (wrap) {
      if (wrap.dataset.solisBioReady) return;
      var text = wrap.querySelector('[data-solis-bio-text]');
      var btn = wrap.querySelector('[data-solis-bio-toggle]');
      if (!text || !btn) return;
      wrap.dataset.solisBioReady = '1';

      // Short bios that fit inside the clamp don't need a toggle.
      if (text.scrollHeight <= text.clientHeight + 4) {
        btn.hidden = true;
        wrap.classList.add('is-short');
        return;
      }

      btn.addEventListener('click', function () {
        var expanded = wrap.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        // Animate to the real content height on expand; back to the CSS clamp on collapse.
        text.style.maxHeight = expanded ? text.scrollHeight + 'px' : '';
      });
    });
  }

  // Run once on initial load (Framia's page:loaded isn't guaranteed on first paint).
  if (document.readyState !== 'loading') {
    applyEnhancements(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      applyEnhancements(document);
    });
  }

  document.addEventListener('page:loaded', function () {
    applyEnhancements(document);
  });

  // PDP: Framia swaps product details on variant switch — re-apply.
  document.addEventListener('variant:changed', function () {
    applyEnhancements(document);
  });

  // Collection: re-apply after a filtered/sorted grid re-renders.
  document.addEventListener('collection:rerendered', function () {
    applyEnhancements(document);
  });
})();

  // SOLIS-KLAVIYO-POPUP-START
  var SOLIS_KLAVIYO_FORM_ID = 'ULNbNs';
  var SOLIS_KLAVIYO_SELECTOR = 'form[data-testid="klaviyo-form-' + SOLIS_KLAVIYO_FORM_ID + '"]';
  var solisKlaviyoObserverStarted = false;

  function initSolisKlaviyoPopup(scope) {
    var root = scope || document;
    var forms = [];

    if (root.nodeType === 1 && root.matches && root.matches(SOLIS_KLAVIYO_SELECTOR)) {
      forms.push(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(SOLIS_KLAVIYO_SELECTOR).forEach(function (form) {
        if (forms.indexOf(form) === -1) forms.push(form);
      });
    }

    forms.forEach(syncSolisKlaviyoForm);
  }

  function syncSolisKlaviyoForm(form) {
    form.classList.add('solis-klaviyo-popup');
    form.dataset.solisKlaviyoReady = '1';

    var richText = findSolisKlaviyoRichText(form);
    if (richText && !richText.querySelector('[data-solis-klaviyo-copy]')) {
      richText.innerHTML = [
        '<div class="solis-klaviyo-copy" data-solis-klaviyo-copy>',
        '<p class="solis-klaviyo-eyebrow">SOLIS PRINTS</p>',
        '<h2 class="solis-klaviyo-heading">A welcome note, three art picks, and 12% off</h2>',
        '<p class="solis-klaviyo-body">Join the Solis list for new releases, artist notes, and curated print edits. We\'ll email your welcome code for 12% off your first order.</p>',
        '<p class="solis-klaviyo-badge">12% off first order</p>',
        '</div>'
      ].join('');
    }

    var emailInput = form.querySelector('input[type="email"], input[name="email"], input[autocomplete="email"]');
    if (emailInput) {
      emailInput.placeholder = 'Email address';
      emailInput.setAttribute('aria-label', 'Email address');
    }

    var submit = form.querySelector('button.klaviyo-form-button, button[type="submit"]');
    if (submit) {
      submit.textContent = 'Email me my welcome code';
      submit.setAttribute('aria-label', 'Email me my welcome code');
      submit.classList.add('solis-klaviyo-submit');
    }

    if (!form.querySelector('[data-solis-klaviyo-microcopy]')) {
      var microcopy = document.createElement('p');
      microcopy.className = 'solis-klaviyo-microcopy';
      microcopy.dataset.solisKlaviyoMicrocopy = '1';
      microcopy.textContent = 'No spam. Unsubscribe any time.';
      var submitRow = submit ? submit.closest('[data-testid="form-row"]') : null;
      if (submitRow && submitRow.parentNode) {
        submitRow.parentNode.insertBefore(microcopy, submitRow.nextSibling);
      } else {
        form.appendChild(microcopy);
      }
    }
  }

  function findSolisKlaviyoRichText(form) {
    var blocks = Array.prototype.slice.call(form.querySelectorAll('.klaviyo-form-richtext'));
    if (!blocks.length) return null;

    return blocks.find(function (block) {
      var text = block.textContent || '';
      return text.indexOf('Art worth knowing') !== -1 || text.indexOf('GET THE ART EDIT') !== -1 || text.indexOf('NL12') !== -1;
    }) || blocks[0];
  }

  function startSolisKlaviyoObserver() {
    if (solisKlaviyoObserverStarted || !window.MutationObserver) return;
    solisKlaviyoObserverStarted = true;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) return;
          if ((node.matches && node.matches(SOLIS_KLAVIYO_SELECTOR)) || (node.querySelector && node.querySelector(SOLIS_KLAVIYO_SELECTOR))) {
            initSolisKlaviyoPopup(node);
          }
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  window.addEventListener('klaviyoForms', function () {
    window.setTimeout(function () { initSolisKlaviyoPopup(document); }, 0);
    window.setTimeout(function () { initSolisKlaviyoPopup(document); }, 250);
  });
  // SOLIS-KLAVIYO-POPUP-END
